









import { Component, Prop, Vue } from "vue-property-decorator";
import { IOrder } from "@/models/orders";

@Component({
  components: {
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue")
  }
})
export default class OrderInvoices extends Vue {
  @Prop({ required: true })
  public order!: IOrder;
}
